import axios from "../axios"

const findByEmail = (form) => {
    return axios.post(`/applicant/find-by-user-login`, form)
        .then(response => response.data.data)
}

const statistics = () => {
    return axios.get(`/applicant/statistics`)
        .then(response => response.data)
}

const storeAvatar = (profileId, formData) => {
    return axios.post( `/applicant/profile/${profileId}/photo/add`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => response.data);
}

const updateAvatar = (profileId, avatarId, formData) => {
    return axios.post( `/applicant/profile/${profileId}/photo/${avatarId}/edit`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => response.data);
}

export default {
    findByEmail,
    statistics,
    storeAvatar,
    updateAvatar,
};